<div class="d-inline-block profit-report">
    <select (change)="selectionChanged()"
            [formControl]="range"
            class="form-control form-control-sm">
        <option *ngFor="let r of ranges" value="{{r}}">
            {{r}}
        </option>
    </select>
</div>

<button (click)="getReport()" *ngIf="!filterOnChange" class="btn btn-primary py-2 ml-1">
    Go
</button>
